import { productsApi } from './index'

export default productsApi.middleware
